import { Typography } from "antd";
import { useQuery } from "@apollo/client";
import { GET_CONTRACTS } from "graphql/contract/query";
import { useParams } from "react-router-dom";
import { useState } from "react";
import moment from "moment";

function useListContract({ isSupplier, sellerID: propSellerID }) {
  const { id: paramSellerID } = useParams();
  const sellerID = propSellerID || paramSellerID;
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const { data, loading } = useQuery(GET_CONTRACTS, {
    variables: {
      filters: Object.fromEntries(
        Object.entries({
          sellerID,
        }).filter(([_, v]) => v !== "" && v !== null && v !== undefined && !(Array.isArray(v) && v.length === 0))
      ),
      pagination: {
        offset: (pagination.current - 1) * pagination.pageSize,
        limit: pagination.pageSize,
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const contracts = data?.contractQuery?.list?.contracts || [];
  const total = data?.contractQuery?.list?.paginationData?.total || 0;

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const columns = [
    {
      title: <span>MÃ HỢP ĐỒNG</span>,
      align: "center",
      render: (_, record) => {
        return (
          <Typography.Link
            strong
            onClick={(e) => {
              e.preventDefault();
              window.open(`/contract/detail/${record.id}?tab=GENERAL_INFO`, "_blank");
            }}
          >
            {record?.code || "-"}
          </Typography.Link>
        );
      },
    },
    {
      title: <span>LOẠI HỢP ĐỒNG</span>,
      align: "center",
      render: (_, record) => {
        const typeMap = {
          FRAMEWORK_AGREEMENT: "Hợp đồng nguyên tắc",
          PURCHASE_AGREEMENT: "Hợp đồng mua bán",
        };
        return <Typography.Text>{typeMap[record?.type] || record?.type}</Typography.Text>;
      },
    },
    {
      title: <span>NGÀY KÝ</span>,
      align: "center",
      render: (_, record) => {
        return (
          <Typography.Text>{record?.startDate ? moment(record?.startDate).format("DD/MM/YYYY") : "-"}</Typography.Text>
        );
      },
    },
    {
      title: <span>NGÀY HẾT HẠN</span>,
      align: "center",
      render: (_, record) => {
        return (
          <Typography.Text>{record?.endDate ? moment(record?.endDate).format("DD/MM/YYYY") : "-"}</Typography.Text>
        );
      },
    },
    {
      title: <span>TRẠNG THÁI</span>,
      dataIndex: "status",
      align: "center",
      render: (status) => {
        const isActive = status === "ACTIVE";
        const isExpired = status === "EXPIRED";
        const isDisabled = status === "DISABLED";

        let color = "#cf1322";
        let bgColor = "rgba(255, 77, 79, 0.15)";
        let borderColor = "rgba(255, 77, 79, 0.5)";
        let text = "Vô hiệu hóa";

        if (isActive) {
          color = "#389e0d";
          bgColor = "rgba(82, 196, 26, 0.15)";
          borderColor = "rgba(82, 196, 26, 0.5)";
          text = "Đang hiệu lực";
        } else if (isExpired) {
          color = "#faad14";
          bgColor = "rgba(255, 197, 61, 0.15)";
          borderColor = "rgba(255, 197, 61, 0.5)";
          text = "Hết hạn";
        }

        return (
          <span
            style={{
              padding: "4px 12px",
              borderRadius: "16px",
              backgroundColor: bgColor,
              border: `1px solid ${borderColor}`,
              color: color,
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: <span>NGƯỜI LẬP HỢP ĐỒNG</span>,
      align: "center",
      width: 200,
      render: (_, record) => {
        return <Typography.Text>{record?.drafterBy?.fullname || record?.drafterBy?.fullname || "-"}</Typography.Text>;
      },
    },
  ];

  return {
    columns,
    dataSource: contracts,
    loading,
    pagination: {
      ...pagination,
      total,
    },
    handleTableChange,
  };
}

export default useListContract;
